import { EnvironmentProviders, Provider } from '@angular/core';
import { MachineCatalogRepository } from './repositories/machine-catalog.repository';
import { MachineCatalogService } from './services/machine-catalog.service';

// Cross-cutting/module-level providers WITHOUT the routes graph — composed at
// boot both by provideMachineCatalog (monolith path) and the remote's
// ./ModuleGlobals entry (federation path). Must not import the routes file.
export function provideMachineCatalogGlobals(): Array<
  Provider | EnvironmentProviders
> {
  return [MachineCatalogRepository, MachineCatalogService];
}
